export default __webpack_public_path__ + "static/media/Instagram_Social_Feed_3.d74310eb.mp4";